import { memo } from 'react';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

const ListSkeleton = () => {
  return (
    <Stack spacing={1} px={1}>
      <Skeleton variant="rounded" width={'100%'} height={64} />
      <Skeleton variant="rounded" width={'100%'} height={64} />
      <Skeleton variant="rounded" width={'100%'} height={64} />
    </Stack>
  )
}

export default memo(ListSkeleton);